<div class="loader-container">
  <span class="loader"></span>
</div>
